export const SPACING_BETWEEN_COLUMNS = 4;
export const SPACING_BETWEEN_BOXES = 3;
export const SPACING_BETWEEN_FORM_FIELDS = 2;
export const SPACING_TO_APPBAR = 8;
export const SPACING_TO_FAB = 4;
